import { baseTheme } from "./base";
const headlines = {
    h1: {
        title: {
            uppercase: true,
            fontWeight: 700,
        },
        subtitle: {
            uppercase: true,
            fontWeight: 400,
        },
        sizes: {
            xsmall: baseTheme.fontTokens.font05,
            medium: baseTheme.fontTokens.font03,
            large: baseTheme.fontTokens.font02,
            xlarge: baseTheme.fontTokens.font01,
        },
    },
    h2: {
        title: {
            uppercase: true,
            fontWeight: 700,
        },
        subtitle: {
            uppercase: true,
            fontWeight: 400,
        },
        sizes: {
            xsmall: baseTheme.fontTokens.font06,
            medium: baseTheme.fontTokens.font05,
            large: baseTheme.fontTokens.font04,
            xlarge: baseTheme.fontTokens.font03,
        },
    },
    h3: {
        title: {
            uppercase: true,
            fontWeight: 700,
        },
        subtitle: {
            uppercase: false,
            fontWeight: 400,
        },
        sizes: {
            xsmall: baseTheme.fontTokens.font07,
            medium: baseTheme.fontTokens.font06,
            large: baseTheme.fontTokens.font05,
            xlarge: baseTheme.fontTokens.font04,
        },
    },
    h4: {
        title: {
            uppercase: true,
            fontWeight: 700,
        },
        subtitle: {
            uppercase: false,
            fontWeight: 400,
        },
        sizes: {
            xsmall: baseTheme.fontTokens.font08,
            medium: baseTheme.fontTokens.font07,
            large: baseTheme.fontTokens.font06,
            xlarge: baseTheme.fontTokens.font05,
        },
    },
    h5: {
        title: {
            uppercase: true,
            fontWeight: 700,
        },
        subtitle: {
            uppercase: false,
            fontWeight: 400,
        },
        sizes: {
            xsmall: baseTheme.fontTokens.font09,
            medium: baseTheme.fontTokens.font08,
            large: baseTheme.fontTokens.font07,
            xlarge: baseTheme.fontTokens.font06,
        },
    },
    h6: {
        title: {
            uppercase: true,
            fontWeight: 700,
        },
        subtitle: {
            uppercase: false,
            fontWeight: 400,
        },
        sizes: {
            xsmall: baseTheme.fontTokens.font10,
            medium: baseTheme.fontTokens.font09,
            large: baseTheme.fontTokens.font09,
            xlarge: baseTheme.fontTokens.font09,
        },
    },
};
export const defaultTheme = Object.assign(Object.assign({}, baseTheme), { headlines });
